module.exports = __webpack_public_path__ + "img/paris-agreement.85c4484f.jpg";